import { useEffect, useState } from 'react';
import { getFullDomain } from './common';

export default function useEnterpriseSingleTab(userType) {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (userType !== 'User') {
      setStatus(false);
      return;
    }

    const APP_NAMESPACE =
      process.env.REACT_APP_MODE === 'LOCAL' ? process.env.REACT_APP_LOCAL_DOMAIN : getFullDomain();

    const CHANNEL = `${APP_NAMESPACE}_tab_channel`;
    const LOCK_KEY = `${APP_NAMESPACE}_tab_owner`;
    const HEARTBEAT_KEY = `${APP_NAMESPACE}_tab_heartbeat`;

    const HEARTBEAT_INTERVAL = 1500; // 1.5 sec
    const HEARTBEAT_TIMEOUT = 4000; // 4 sec (must be > interval)

    const tabId =
      sessionStorage.getItem('crm_tab_id') ||
      `${Date.now()}-${Math.random().toString(36).slice(2)}`;

    sessionStorage.setItem('crm_tab_id', tabId);

    const channel = new BroadcastChannel(CHANNEL);

    const now = () => Date.now();

    const getOwner = () => localStorage.getItem(LOCK_KEY);
    const getHeartbeat = () => parseInt(localStorage.getItem(HEARTBEAT_KEY) || '0', 10);

    const isOwnerAlive = () => {
      const lastBeat = getHeartbeat();
      return now() - lastBeat < HEARTBEAT_TIMEOUT;
    };

    const claimOwnership = () => {
      localStorage.setItem(LOCK_KEY, tabId);
      localStorage.setItem(HEARTBEAT_KEY, now().toString());
      setStatus(false);
    };

    const currentOwner = getOwner();

    if (!currentOwner) {
      claimOwnership();
    } else if (currentOwner === tabId) {
      claimOwnership();
    } else if (!isOwnerAlive()) {
      claimOwnership();
    } else {
      setStatus(true);
    }

    const heartbeatInterval = setInterval(() => {
      if (getOwner() === tabId) {
        localStorage.setItem(HEARTBEAT_KEY, now().toString());
      }
    }, HEARTBEAT_INTERVAL);

    channel.onmessage = (event) => {
      if (!event.data) return;

      const { type, tabId: incomingTabId } = event.data;

      if (type === 'TAB_OPENED') {
        if (getOwner() === tabId && incomingTabId !== tabId) {
          channel.postMessage({ type: 'BLOCK_NEW_TAB' });
        }
      }

      if (type === 'BLOCK_NEW_TAB') {
        if (getOwner() !== tabId) {
          setStatus(true);
        }
      }
    };

    channel.postMessage({ type: 'TAB_OPENED', tabId });

    const handleUnload = () => {
      if (getOwner() === tabId) {
        localStorage.removeItem(LOCK_KEY);
        localStorage.removeItem(HEARTBEAT_KEY);
      }
    };

    window.addEventListener('beforeunload', handleUnload);

    return () => {
      clearInterval(heartbeatInterval);
      window.removeEventListener('beforeunload', handleUnload);
      channel.close();
    };
  }, [userType]);

  return status;
}
